import revolistRevogridGlobalScript from 'E:/repos/EmbarkBlackBook.Web/embark-black-book-web/node_modules/@revolist/revogrid/dist/collection/global/global.js';
import appGlobalScript from 'E:/repos/EmbarkBlackBook.Web/embark-black-book-web/src/global/app.ts';
export const globalScripts = () => {
  return Promise.all([
    appGlobalScript(),
    revolistRevogridGlobalScript(),
  ]);
};
